import market from './eurlate/market'
import coupon from './eurlate/coupon'
import member from './member'
import memberLevel from './memberLevel'
import knowledgeBase from './knowledgeBase'

export default {
  mmc: {
    ...member,
    eurlate: {
      ...market
    },
    campaign: {
      ...coupon
    },
    ...memberLevel,
    ...knowledgeBase
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/mmc/mmc.js